var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlueMarker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(11.764706%,66.666667%,76.862745%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 20 0.497159 C 30.767045 0.497159 39.502841 9.232955 39.502841 20 C 39.502841 30.767045 30.767045 39.502841 20 39.502841 C 9.232955 39.502841 0.497159 30.767045 0.497159 20 C 0.497159 9.232955 9.232955 0.497159 20 0.497159 Z M 20 0.497159 ",
    transform: "matrix(0.55,0,0,0.55,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(11.764706%,66.666667%,76.862745%)",
      fillOpacity: 1
    },
    d: "M 11 5.28125 C 14.160156 5.28125 16.71875 7.839844 16.71875 11 C 16.71875 14.160156 14.160156 16.71875 11 16.71875 C 7.839844 16.71875 5.28125 14.160156 5.28125 11 C 5.28125 7.839844 7.839844 5.28125 11 5.28125 Z M 11 5.28125 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueMarker);
export default __webpack_public_path__ + "static/media/blue-marker.e1e55b50345484ce2b59cf9c2f02c42f.svg";
export { ForwardRef as ReactComponent };